import styled from 'styled-components';

import { Box } from 'components/Box';
import { colors, transition } from 'theme';

export const ArrowNavigationContainer = styled(Box)<{
  $outset?: boolean;
  $showDropShadow?: boolean;
  $buttonColor?: string;
}>`
  position: absolute;
  ${(props) =>
    !props.top &&
    `
    top: 50%;
  `}
  ${(props) =>
    props.width
      ? ``
      : `
      width: ${props.$outset ? 'calc(100% + 128px)' : '100%'};
    `};
  max-width: calc(100vw - 16px);
  pointer-events: none;

  ${(props) =>
    props.$outset
      ? `
    left: 50%;
    transform: translate(-50%, -50%);
    button {
      display: flex;
      width: 40px;
      height: 40px;
      padding: 0;
      justify-content: center;
      align-items: center;
      color: white;
      background: ${colors.brandBlue};
      border-radius: 50%;
      pointer-events: auto;
      transition: all ${transition};
      svg {
        * {
          fill: currentColor;
        }
      }
      &[disabled] {
        opacity: 0.33;
        &:hover {
          background: ${colors.brandBlue};
        }
      }
      &:hover,
      &:focus {
        background: ${colors.brandGreen};
      }
    }`
      : `
    left: 0;
    transform: translateY(-50%);
    button {
      background: transparent;
      appearance: none;
      border: 0;
      padding: 0;
      pointer-events: all;
      color: ${props.$buttonColor || colors.brandBlue};
      ${
        props.$showDropShadow &&
        `
          filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.35));
        `
      }
      svg {
        * {
          fill: currentColor;
        }
      }
      &[disabled] {
        opacity: 0.33;
      }
    }
  `}
`;
